/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'
import { hFlex, overlay, square } from '../../../Styles/style-helpers'
import { Text } from '../../../Styles/typography'
import { background1 } from '../../../Styles/colors'

export const ArtistEl = styled.div`
  position: relative;
  width: 100%;
  padding: 2em 0;

  .row {
    width: 100%;
    ${hFlex};
    align-items: flex-start;
    margin-bottom: 2.5em;
  }
`

export const SubtitleEl = styled(Text)`
  text-transform: uppercase;
`

export const CoverEl = styled.div`
  position: relative;
  ${square('15em')};
  border-radius: 0.5em;
  margin: 2em auto;
  overflow: hidden;
  background: ${background1};

  img {
    ${overlay};
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: 50% 0;
  }
`

export const InfoEl = styled.div`
  padding: 0 1em;
  flex: 1;

  h4 {
    font-weight: bold;
    margin: 1.5em 0;
    letter-spacing: 0.025em;
  }

  p {
    line-height: 1.5;
  }
`

export const ClassesEl = styled.div`
  width: 100%;
  padding: 2em 0;
  transform: translateX(-1em);
`

export const ClassesControlsEl = styled.div`
  width: 100%;
  padding: 1em;
  ${hFlex};
  justify-content: space-between;

  .controls {
    & > button {
      background: #333;
      border-radius: 0.5em;
      font-size: 1em;
      margin-right: 0.25em;
      transform: scale(0.85);

      &.Mui-disabled {
        opacity: 0.5;
      }

      svg {
        fill: white;
      }

      &:first-of-type {
        transform: scale(-0.85);
      }
    }
  }
`
